import adminSmallEverad from '../assets/img/default-avatars/sup_40x40.png';
import adminSmallRocket from '../assets/img/default-avatars/rocket_sup_40x40.png';
import affiliateFull from '../assets/img/default-avatars/web_300x300.png';
import affiliateSmall from '../assets/img/default-avatars/web_40x40.png';
export default {
	adminSmall: process.env.CPA_ENV === 'everad' ? adminSmallEverad : adminSmallRocket,
	affiliateFull,
	affiliateSmall
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/config/avatars.js